import _ from 'lodash';
import {
  get,
  post,
  put,
  del, } from 'utils/fetch';
import { 
  createAction,
  entity_reducer,
  list_reducer,
  list_remove } from 'utils/store';
import { Storage, RequestState } from 'constants/constants';
import { selectApiHost, selectApiToken } from 'store/AppState';

export const selectYouTubeSearch = (state, id) => state.models.youtube.searchResults;
  
export const SEARCH_YOUTUBE_USER = 'SEARCH_YOUTUBE_USER';

const Entity = {
  actions: {
    searchUsers: (channel) => {
      return (dispatch, getState) => get({
        url: "/api/youtube/search", 
        params: { channel },
        dispatch, 
        action: SEARCH_YOUTUBE_USER,
        host: selectApiHost(getState()),
      });
    },

    channelFromUrl: (url) => {
      return (dispatch, getState) => get({
        url: "/api/youtube/search_url", 
        params: { url },
        dispatch, 
        action: SEARCH_YOUTUBE_USER,
        host: selectApiHost(getState()),
      });
    },
  },

  spec: {
    youtube: {
      searchResults: null,
    }
  },

  reducer: (state, type, body, action, json) => {
    if (action.url && action.result === RequestState.REQUEST) 
      return state;

    switch(type) {
      case SEARCH_YOUTUBE_USER:
        return { ...state, youtube: { ...state.youtube, searchResults: body } };
      default:
        return state;
    }
    return state;
  },
}
_.bindAll(Entity.actions, _.functions(Entity.actions));
export default Entity;
  